export default __webpack_public_path__ + "static/media/main-premium-bg-4.b55b8217.png";